import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';
import {
  showAdjustmentModalForAddEdit,
  showAdjustmentModalForDelete,
  showModalForAttachments,
} from './store/actions';

class OptionsCellRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      adjustmentId: PropTypes.string.isRequired,
      autoAdjustmentId: PropTypes.number,
      manualAmount: PropTypes.number,
      amount: PropTypes.number,
    }).isRequired,
    rowIndex: PropTypes.number.isRequired,
    showAdjustmentModalForAddEdit: PropTypes.func.isRequired,
    showAdjustmentModalForDelete: PropTypes.func.isRequired,
    showModalForAttachments: PropTypes.func.isRequired,
  };

  showAdjustmentModalForEdit = () => {
    const { value } = this.props;
    this.props.showAdjustmentModalForAddEdit({
      ...value,
      amount: value.manualAmount || value.amount,
    });
  };

  showAdjustmentModalForDelete = () => {
    const { value, rowIndex } = this.props;

    this.props.showAdjustmentModalForDelete({
      ...value,
      rowIndex,
    });
  };

  showModalForAttachments = () => {
    this.props.showModalForAttachments(this.props.value);
  };

  render() {
    const { value } = this.props;

    return (
      <span>
        {value.autoAdjustmentId ? null : (
          <button
            className="cell-icon-button"
            title="Edit Adjustment"
            onClick={this.showAdjustmentModalForEdit}
          >
            <PencilIcon size={16} className="cell-icon" />
          </button>
        )}
        {value.autoAdjustmentId ? null : (
          <button
            className="cell-icon-button"
            title="Delete Adjustment"
            onClick={this.showAdjustmentModalForDelete}
          >
            <TrashIcon size={16} className="cell-icon" />
          </button>
        )}
      </span>
    );
  }
}

export default connect(
  null,
  {
    showAdjustmentModalForAddEdit,
    showAdjustmentModalForDelete,
    showModalForAttachments,
  }
)(OptionsCellRenderer);
